import React, { type MouseEvent } from 'react';
import { FormattedI18nMessage } from '@atlassian/jira-formatted-i18n-message/src/ui/index.tsx';
import HelpPanelLink from '@atlassian/jira-help-panel-button';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, type UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import {
	LEARN_MORE_LINK_SELECTOR,
	inProductHelpButtonForPrioritySchemesUIEvent,
} from '../../../common/constants';
import { messages } from './messages';

const ARTICLE_ID = 'YzlOU0xe92Dnzhz8yXfz6';
export const FALLBACK_URL =
	'https://support.atlassian.com/jira-cloud-administration/docs/manage-priority-schemes/';

const FallbackHelpLink = () => {
	const { formatMessage } = useIntl();
	return (
		<a href={FALLBACK_URL} target="_blank" rel="noopener noreferrer">
			{formatMessage(messages.learnMoreLink)}
		</a>
	);
};

export const HeaderDescription = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<p data-testid={LEARN_MORE_LINK_SELECTOR}>
				<FormattedI18nMessage
					componentsMapping={{
						link: ({ children }) => (
							<HelpPanelLink
								appearance="link"
								spacing="none"
								fallbackComponent={<FallbackHelpLink />}
								articleId={ARTICLE_ID}
								onClick={(_event: MouseEvent, analyticsEvent: UIAnalyticsEvent) => {
									fireUIAnalytics(
										analyticsEvent,
										inProductHelpButtonForPrioritySchemesUIEvent.actionSubjectId,
									);
								}}
							>
								{children}
							</HelpPanelLink>
						),
					}}
					message={formatMessage(messages.prioritySchemesDescription, {
						linkStart: '{linkStart}',
						linkEnd: '{linkEnd}',
					})}
				/>
			</p>
			<p>{formatMessage(messages.defaultPrioritySchemeDescription)}</p>
			<p>{formatMessage(messages.findPrioritiesDescription)}</p>
		</>
	);
};
